import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Filters from 'components/Filters/Filters';
import Results from 'components/Results/Results';

import OldBackImage from 'static/img/old-banner.jpg';
import OthersBackImage from 'static/img/others-banner.png';

import './Seeker.css';

declare var CONFIGURATIONS;

class Seeker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      results: [],
      collections: this.props.collections,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({ collections: nextProps.collections });
  }

  updateResults = (newResults) => {
    this.setState({ results: newResults });
  }

  render() {
    const { block, unblock } = this.props;
    const { results, collections } = this.state;
    const searchOption = window.location.href.split('/catalogocartoteca/search/')[1].trim();
    const collection = collections.length > 0 ? collections.filter((c) => c.name === searchOption)[0].title : '';

    return (
      <div className='seekerContainer'>
        <div className='bannerContainer' style={{ backgroundImage: (searchOption === 'cartografia-antigua' ? `url(${OldBackImage})` : `url(${OthersBackImage})`) }}>
          { searchOption === 'cartografia-antigua' ?
            <div>Cartografía antigua</div>
          : <div>Otras cartografías</div> }
        </div>
        <div className='textContainer'>
          { searchOption === 'cartografia-antigua' ?
            <div style={{ display: 'block', textAlign: 'left' }}>
              <p>El fondo cartográfico antiguo del Instituto Geográfico de Aragón conserva una valiosa colección de mapas originales que datan del siglo XVII hasta el primer tercio del siglo XX. Esta colección incluye ediciones de origen holandés, francés, italiano, español, entre otras, junto con documentos de interés geográfico, como atlas e itinerarios.</p>
              <p>El propósito es continuar ampliando este rico patrimonio mediante la adquisición de nuevos ejemplares, destacando así su relevancia y contribuyendo a su conservación. Además, esta colección no solo refleja la evolución histórica de la cartografía, sino también el contexto cultural, político y científico de las épocas en que se produce.
A través de la investigación, la digitalización y la divulgación, se busca acercar este legado tanto a especialistas como al público en general, promoviendo su estudio y asegurando su preservación para las generaciones futuras. Con ello, se refuerza nuestro compromiso de protección y puesta en valor.</p>
            </div>
          : <div style={{ display: 'block', textAlign: 'left' }}>
            <p>En esta sección de la Cartoteca Digital de Aragón se muestran colecciones temáticas que proceden, principalmente, de instituciones geográficas públicas. El Instituto Geográfico de Aragón las ha escaneado, georreferenciado, en su gran mayoría, y asignado los metadatos correspondientes con el propósito de preservarlas y ponerlas a disposición de la sociedad en su conjunto.</p>
            <p>Los documentos de este repositorio, que van a estar en continuo crecimiento y abiertos a formar parte de futuras colecciones, pueden consultarse en línea, visualizarse y descargarse a alta resolución.</p>
          </div> }
        </div>
        { collection !== '' ?
          <div className='breadCrumbs'>
            <p><a href='/catalogocartoteca/home'>Colecciones</a>&nbsp;&nbsp;/&nbsp;&nbsp;{ searchOption === 'cartografia-antigua' ? collection : 'Otras cartografías'}</p>
          </div>
        : null }
        <div className='filterResultsContainer'>
          <Filters block={block} unblock={unblock} updateResults={this.updateResults} searchOption={searchOption} collections={collections} />
          <Results block={block} unblock={unblock} results={results} searchOption={searchOption} />
        </div>
      </div>
    );
  }
}

export default translate()(Seeker);
